export default {"src":"/_next/static/media/home-protect-icon.ac9e26e4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};